import { render } from "./InlineDescriptor.vue?vue&type=template&id=6aba4876&ts=true"
import script from "./InlineDescriptor.vue?vue&type=script&lang=ts"
export * from "./InlineDescriptor.vue?vue&type=script&lang=ts"

import "./InlineDescriptor.vue?vue&type=style&index=0&id=6aba4876&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__